import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Bell } from 'lucide-react'
import useLoginStore from '@/store/LoginStore'

/** Inbox zero (design 17b): one screen, no second pane. */
export function NotificationsEmptyState() {
  const { t } = useTranslation('notifications')
  const workspaceSlug = useLoginStore((s) => s.workspaceSlug)
  return (
    <div className="flex h-full min-h-0 w-full items-center justify-center p-4 md:p-6">
      <div
        data-testid="notifications-empty"
        className="flex w-full max-w-[560px] flex-col items-center rounded-xl border bg-card px-6 py-14 text-center"
      >
        <span className="mb-4 flex size-11 items-center justify-center rounded-lg bg-secondary">
          <Bell className="size-5 text-muted-foreground" />
        </span>
        <h1 className="text-[15px] font-semibold">{t('empty.title')}</h1>
        <p className="mt-1.5 max-w-[300px] text-[13px] leading-relaxed text-muted-foreground">
          {t('empty.description')}
        </p>
        <Link
          to="/$workspaceSlug/settings/notifications"
          params={{ workspaceSlug }}
          className="mt-3 text-[13px] font-medium text-foreground underline decoration-border underline-offset-4 hover:decoration-foreground"
        >
          {t('empty.settingsLink')}
        </Link>
      </div>
    </div>
  )
}
